import { ImResponse, resolve, storeHomeClient } from '.';

export interface RecepotionPiority {
  storeGroupConfigId: number;
  pauseAutoReplyGroupId?: number;
  humanFirst: boolean;
  pauseAi: boolean;
  pauseMinute: number;
}

export type GetReceptionPriorityParams = Util.RequireAtLeastOne<{
  storeGroupId: string | number;
  storeId: string | number;
}>;

export const getReceptionPriority = (params: GetReceptionPriorityParams) => {
  return resolve(
    storeHomeClient.get<ImResponse<RecepotionPiority>>('/store_groups/reception_priority', {
      params,
    }),
  );
};

export const updateReceptionPriority = (body: RecepotionPiority) => {
  return storeHomeClient.post('/store_group_configs/reception_priority', body);
};
